<script>
    import Lightbox from "./Lightbox.svelte";
    export let items;
</script>

<style>
    @media only screen and (max-width: 768px) {
        .hidden-on-mobile {
            display: none;
        }
    }
</style>

<div style="margin:auto; padding: 0px 40px;">
    <table>
        <tbody>
            <tr>
                {#each items as item, i}
                    <td align="center" class={i > 1 ? "hidden-on-mobile" : ""}>
                        <Lightbox description={item.detail} portrait image={item}>
                            <img
                                src={item.path}
                                alt={item.alt}
                                style={item.style} />
                        </Lightbox>
                    </td>
                {/each}
            </tr>
        </tbody>
    </table>
</div>
